/*--------------------------------------
	관리자 메뉴관리 (설정 > 관리자 메뉴관리)
	목록 클릭 → 편집 폼 채움 / 저장·삭제(ajax) / 행 드래그로 순서 재배치.
	노출조건은 레벨 AND 부서 — 둘 다 비우면 제한 없음.
	라우트: /adm/menus, /adm/ajax/menus/{save,delete,reorder}
--------------------------------------*/
import Util from '../../Common/Util';
export default class AdminMenu {
	/**
	 * 기본홈 쿠키 — **이 브라우저에만** 남는다(계정 설정이 아니다).
	 * ⚠ 경계키: 값이 PHP 상수와 같아야 한다 — G5_COOKIE_ADM_HOME (app/Common/constants.php).
	 *   읽는 쪽 정본은 App\Common\AdminHome (로그인 리다이렉트·로고 링크).
	 */
	static CK_HOME = 'ADMHOME';

	initialize(){
		this.bind();
		this.bindDrag();
		this.bindHome();
		this.markHome();
	}

	/** 지금 기본홈. 고른 적이 없으면 빈 값 — 표시는 '접수목록(기본)' 으로 한다 */
	get home(){ return $j.Common.Store.cookie.get(AdminMenu.CK_HOME) || ''; }

	bindHome(){
		const self = this;

		// 집 아이콘 — 행 클릭(편집 폼 로드)과 겹치므로 전파를 끊는다
		$(document).on('click.admenu', '.js-home', function(e){
			e.preventDefault();
			e.stopPropagation();

			const url = $(this).data('url') + '';

			// 같은 것을 다시 누르면 해제 — 기본값(접수목록)으로 돌아간다.
			// **알림은 띄우지 않는다** — 아이콘이 옮겨 붙고 머리말의 이름이 바뀌는 것이
			// 이미 결과를 말한다. 눈에 보이는 일에 토스트를 겹치면 잔소리가 된다
			if (self.home === url) $j.Common.Store.cookie.remove(AdminMenu.CK_HOME);
			else                   $j.Common.Store.cookie.set(AdminMenu.CK_HOME, url, { days: 3650 });

			self.markHome();
		});
	}

	/** 지금 기본홈인 줄의 집 아이콘을 칠한다 */
	markHome(){
		const cur = this.home;

		$('.js-home').each(function(){
			const on = $(this).data('url') + '' === cur;
			$(this).toggleClass('text-primary', on).toggleClass('text-muted', !on);
			$(this).find('i').attr('class', on ? 'fas fa-house-user' : 'far fa-circle');
		});

		const $now = $('#homeNow');
		if (!$now.length) return;

		const $on = $('.js-home').filter((i, b) => $(b).data('url') + '' === cur);
		$now.text($on.length ? $on.data('title') + '' : '접수목록 (기본값)');
	}

	bind(){
		const self = this;
		$(document).off('.admenu');

		// 목록 행 클릭 → 편집 폼에 로드
		$(document).on('click.admenu', '.js-menu-row', function(){
			const $tr = $(this);
			$('#menuNum').val($tr.attr('data-num'));
			$('#menuTitle').val($tr.attr('data-title') || '');
			$('#menuUrl').val($tr.attr('data-url') || '');
			$('#menuDepth').val($tr.attr('data-depth') || '1');
			$('#menuOdr').val($tr.attr('data-odr') || '');
			$('#menuIcon').val($tr.attr('data-icon') || '');
			$('#menuLevel').val($tr.attr('data-level') || '');
			self.setDepts($tr.attr('data-department') || '');

			$('#menuTable .js-menu-row').removeClass('table-active');
			$tr.addClass('table-active');
		});

		// 새 메뉴 — 폼 비우기
		$(document).on('click.admenu', '.js-menu-new', function(){
			$('#menuNum').val('');
			$('#menuTitle').val('');
			$('#menuUrl').val('');
			$('#menuDepth').val('2');
			$('#menuOdr').val('');
			$('#menuIcon').val('');
			$('#menuLevel').val('');
			self.setDepts('');
			$('#menuTable .js-menu-row').removeClass('table-active');
			$('#menuTitle').focus();
		});

		$(document).on('click.admenu', '.js-menu-save', function(){ self.save(); });
		$(document).on('click.admenu', '.js-menu-del', function(){ self.remove(); });
	}

	/**
	 * 행 드래그로 순서 재배치 (HTML5 DnD — 관리자는 데스크탑 전용이라 터치는 고려하지 않는다).
	 * dragover 에서 행을 즉시 옮겨 끌리는 위치가 그대로 보이게 하고,
	 * 놓았을 때 순서가 실제로 바뀐 경우에만 서버에 보낸다.
	 *
	 * 끄는 단위는 **대메뉴면 하위 중메뉴까지 한 덩어리**, 중메뉴면 그 행 하나다.
	 * 대메뉴 덩어리는 남의 그룹 중간에 못 끼운다 — 거기 놓으면 그 그룹의 중메뉴를
	 * 빼앗아버리기 때문에, 커서가 가리키는 그룹의 위/아래(경계)로 붙인다.
	 */
	bindDrag(){
		const self  = this;
		const tbody = document.querySelector('#menuTable tbody');
		if(!tbody) return;
		$(tbody).off('.admenu');

		this.$block = null;      // 끌고 있는 행들
		this.orderBefore = '';

		$(tbody).on('dragstart.admenu', 'tr.js-menu-row', function(e){
			self.$block      = self.blockOf($(this));
			self.orderBefore = self.currentOrder().join(',');
			self.$block.addClass('menu-dragging');
			// 파이어폭스는 데이터가 없으면 드래그를 시작하지 않는다
			const dt = e.originalEvent.dataTransfer;
			if(dt){ dt.effectAllowed = 'move'; dt.setData('text/plain', $(this).attr('data-num')); }
		});

		$(tbody).on('dragover.admenu', 'tr.js-menu-row', function(e){
			const $block = self.$block;
			if(!$block) return;
			e.preventDefault();

			const $over = $(this);
			if( $block.filter($over).length ) return; // 끌고 있는 덩어리 자신

			// 커서가 행의 위쪽 절반이면 앞에, 아래쪽 절반이면 뒤에
			const rect = this.getBoundingClientRect();
			const after = (e.originalEvent.clientY - rect.top) > rect.height / 2;

			// 대메뉴 덩어리는 커서가 가리키는 그룹 통째의 앞/뒤로만 간다
			let $anchor = $over;
			if( self.isTop($block.first()) ){
				const $group = self.blockOf(self.topOf($over));
				$anchor = after ? $group.last() : $group.first();
			}
			// 중메뉴가 맨 위로 가면 붙을 대메뉴가 없어진다
			else if( !after && $anchor.prevAll('tr.js-menu-row').not($block).length === 0 ){
				return;
			}

			after ? $anchor.after($block) : $anchor.before($block);
		});

		$(tbody).on('dragend.admenu', 'tr.js-menu-row', function(){
			if(!self.$block) return;
			self.$block.removeClass('menu-dragging');
			self.$block = null;

			const now = self.currentOrder();
			if( now.join(',') === self.orderBefore ) return; // 제자리에 놓음
			self.reorder(now);
		});

		// 행 위에서 놓을 때 브라우저 기본동작(주소 열기 등) 차단
		$(tbody).on('drop.admenu', 'tr.js-menu-row', function(e){ e.preventDefault(); });
	}

	/** 대메뉴(depth 1) 행인가 */
	isTop($tr){
		return $tr.attr('data-depth') === '1';
	}

	/** 그 행이 속한 대메뉴 행 (자기가 대메뉴면 자기) */
	topOf($tr){
		if( this.isTop($tr) ) return $tr;
		const $prev = $tr.prevAll('tr.js-menu-row[data-depth="1"]').first(); // prevAll 은 가까운 것부터
		return $prev.length ? $prev : $tr;
	}

	/** 끌고 다닐 덩어리 — 대메뉴면 다음 대메뉴 직전까지, 중메뉴면 그 행 하나 */
	blockOf($tr){
		if( !this.isTop($tr) ) return $tr;
		return $tr.add($tr.nextUntil('tr.js-menu-row[data-depth="1"]', 'tr.js-menu-row'));
	}

	/** 지금 화면에 보이는 순서의 메뉴번호 목록 */
	currentOrder(){
		return $('#menuTable tbody tr.js-menu-row').map(function(){ return $(this).attr('data-num'); }).get();
	}

	/** '3,9' → 해당 체크박스만 체크 */
	setDepts(csv){
		const picked = String(csv || '').split(',').filter(v => v !== '');
		$('.js-menu-dept').each(function(){
			$(this).prop('checked', picked.indexOf($(this).val()) > -1);
		});
	}

	getDepts(){
		return $('.js-menu-dept:checked').map(function(){ return $(this).val(); }).get();
	}

	save(){
		const num   = $('#menuNum').val();
		const title = $.trim($('#menuTitle').val());
		const odr   = $('#menuOdr').val();
		if( !title ){ Util.swalert('메뉴명을 입력하세요.'); return; }
		if( !odr )  { Util.swalert('순서를 입력하세요.'); return; }

		$.ajax({
			type: 'post', url: '/adm/ajax/menus/save', dataType: 'json',
			data: {
				num,
				title,
				url:   $.trim($('#menuUrl').val()),
				depth: $('#menuDepth').val(),
				level: $('#menuLevel').val(),
				icon:  $.trim($('#menuIcon').val()),
				odr,
				departments: this.getDepts()
			},
			success: function(res){
				if( res && res.result ) Util.swalert('저장되었습니다.', () => location.reload());
				else                    Util.swalert((res && res.msg) || '저장에 실패했습니다.');
			}
		});
	}

	remove(){
		const num = $('#menuNum').val();
		if( !num ){ Util.swalert('삭제할 메뉴를 선택하세요.'); return; }
		Util.swalert('이 메뉴를 삭제할까요?', () => {
			$.ajax({
				type: 'post', url: '/adm/ajax/menus/delete', dataType: 'json',
				data: { num },
				success: function(res){
					if( res && res.result ) Util.swalert('삭제되었습니다.', () => location.reload());
					else                    Util.swalert((res && res.msg) || '삭제에 실패했습니다.');
				}
			});
		});
	}

	/** 드래그로 만든 순서를 저장 — 성공하면 다시 그린다(순서값·상위메뉴 재계산 반영) */
	reorder(nums){
		$.ajax({
			type: 'post', url: '/adm/ajax/menus/reorder', dataType: 'json',
			data: { nums },
			success: function(res){
				if( res && res.result ) location.reload();
				else                    Util.swalert((res && res.msg) || '순서 저장에 실패했습니다.', () => location.reload());
			},
			error: function(){ Util.swalert('순서 저장 중 오류가 발생했습니다.', () => location.reload()); }
		});
	}

	destroy(){
		$(document).off('.admenu');
		$('#menuTable tbody').off('.admenu');
	}
}
